import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useT } from '@/lib/i18n';

export function BookingStatusModal() {
  const { t } = useT();

  return (
    <div className="fixed inset-0 bg-black/60 flex overflow-hidden items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white dark:bg-neutral-800 rounded-xl max-w-md w-full p-8 text-center"
      >
        <Loader2 className="w-16 h-16 text-primary-500 animate-spin mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2 dark:text-neutral-100">{t('booking.processing.title')}</h2>
        <p className="text-dark-muted dark:text-neutral-400">
          {t('booking.processing.subtitle')}
        </p>
      </motion.div>
    </div>
  );
}

